<template>
  <ims-button class="btn btn-icon ims-back-button" @click="back()">
    <ims-icon class="mr-2" icon="arrow_back" />
  </ims-button>
</template>

<script>
export default {
  methods: {
    back() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
</style>
